import React from "react"
import { NavLink, Route } from "react-router-dom"
import { ROUTES } from "../../common/utils"
import {
  HomeIcon,
  CustomerIcon,
  BoxIcon,
  ClipboardIcon,
  SettingsIcon,
  InventoryIcon,
  LeftArrowIconCircular,
  DiagramIcon
} from "../../common/Icons"
import "./AdminSidebar.css"

function ProductsSubMenu() {
  return (
    <div className="sub-menu">
      <NavLink
        to={{
          pathname: ROUTES.ALL_PRODUCTS,
          search: "?page=1&per_page=25"
        }}
      >
        <span>All Products</span>
      </NavLink>
      <NavLink
        to={{
          pathname: ROUTES.CATEGORIES,
          search: "?page=1&per_page=25"
        }}
      >
        <span>Categories</span>
      </NavLink>
    </div>
  )
}

class AdminSidebar extends React.Component {
  constructor(props) {
    super(props)
    this.state = { icon_only: false }
  }

  handleToggle = () => {
    this.setState(state => ({ ...state, icon_only: !this.state.icon_only }))
    this.props.setSidebarHidden(!this.state.icon_only)
  }

  handleShowSubmenu = () => {
    if (this.state.icon_only) {
      this.setState(state => ({ ...state, icon_only: false }))
    }
  }

  componentDidMount() {
    this.props.setSidebarHidden(this.state.icon_only)
  }

  render() {
    return (
      <div
        className={`Parent-sidebar ${
          this.state.icon_only ? "Icon-only-sidebar" : ""
        }`}
      >
        <div className={`AdminSidebar `}>
          <nav>
            <div>
              <NavLink exact to={ROUTES.DASHBOARD}>
                <HomeIcon />
                <span>Home</span>
              </NavLink>
              <NavLink
                to={{
                  pathname: ROUTES.ORDERS,
                  search: "?page=1&per_page=25"
                }}
              >
                <ClipboardIcon />
                <span>Orders</span>
              </NavLink>
              <NavLink
                to={{
                  pathname: ROUTES.CUSTOMER,
                  search: "?filter=total&page=1&per_page=25"
                }}
              >
                <CustomerIcon />
                <span>Customers</span>
              </NavLink>
              <NavLink
                onClick={this.handleShowSubmenu}
                to={{
                  pathname: ROUTES.PRODUCT,
                  search: "?filter=total&page=1&per_page=25"
                }}
              >
                <BoxIcon />
                <span>Products</span>
              </NavLink>
              <Route
                path={ROUTES.PRODUCT}
                render={props => <ProductsSubMenu {...props} />}
              />
              <NavLink
                to={{
                  pathname: ROUTES.INVENTORY,
                  search: "?page=1&per_page=25"
                }}
              >
                <InventoryIcon />
                <span>Inventory</span>
              </NavLink>
              <NavLink
                to={{
                  pathname: ROUTES.REPORTS,
                  search: `?metric_code=sales&timeframe=daily`
                }}
              >
                <DiagramIcon />
                <span>Reports</span>
              </NavLink>
              <NavLink
                to={{
                  pathname: ROUTES.SETTINGS
                }}
              >
                <SettingsIcon />
                <span>Settings</span>
              </NavLink>
            </div>
          </nav>
        </div>
        <span className="arrow" onClick={this.handleToggle}>
          <LeftArrowIconCircular />
        </span>
      </div>
    )
  }
}

export default AdminSidebar
